<template>
  <b-modal
    id="modal-integration-shell"
    modal-class="mc-modal-integration-shell"
    :title="'Update to Shell ' + detailData?.number"
    size="md"
    centered
    scrollable
    @show="onModalShow"
  >
    <div>
      <FormulateForm ref="formRef" v-model="formValues" class="mc-form mb-2" :errors="formErrors">
        <FormulateInput
          id="eventStatus"
          name="eventStatus"
          label="Status"
          placeholder="Pilih Status"
          type="select-resourceful-v2"
          :optionsGetter="resourcefulQuery.statusOption"
          :optionLabelFn="({ item }) => item.label"
          trackBy="key"
          :fullObject="fullObject.eventStatus"
          validation="required"
          validation-behavior="submit"
          help="Wajib Terisi"
          @update:fullObject="($event) => (fullObject.eventStatus = $event)"
        />
        <FormulateInput
          id="eventTime"
          name="eventTime"
          label="Tanggal"
          placeholder="Pilih Tanggal"
          type="date-picker"
          datepickerType="datetime"
          valueType="YYYY-MM-DDTHH:mm:ss.SSSZ"
          validation="required"
          validation-behavior="submit"
          format="DD MMM YYYY HH:mm"
          :showSecond="false"
          :confirm="true"
          confirmText="Terapkan"
          help="Wajib Terisi"
          lang="{
            formatLocale: {
              weekdaysMin: ['Sen', 'Sel', 'Rab', 'Kam', 'Jum', 'Sab', 'Min'],
            },
          }"
        />
      </FormulateForm>
    </div>

    <template #modal-footer>
      <McButton
        variant="secondary"
        class="me-2"
        :text="$t('global.action.cancel')"
        @click="$bvModal.hide('modal-integration-shell')"
      />
      <McButton
        variant="primary"
        class="me-2"
        :text="$t('global.alert.text.confirm')"
        @click="handleConfirm"
      />
    </template>
  </b-modal>
</template>

<script>
import { MixPanel } from '@/mixin/mixpanel'
import McButton from '@/components/McButton'
import * as DeliveryOrder from '@/services/rest-api/lib/delivery/delivery-order'

export default {
  components: {
    McButton,
  },
  mixins: [MixPanel],
  props: {
    detailData: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    const toLocalISOString = (date = new Date()) => {
      const tzOffset = -date.getTimezoneOffset()
      const diff = tzOffset >= 0 ? '+' : '-'
      const pad = (n) => `${Math.floor(Math.abs(n))}`.padStart(2, '0')
      const hours = pad(tzOffset / 60)
      const minutes = pad(tzOffset % 60)
      return `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())}T${pad(
        date.getHours()
      )}:${pad(date.getMinutes())}:${pad(date.getSeconds())}.000${diff}${hours}:${minutes}`
    }

    const statusOptions = [
      { key: 'Vehicle Arrived', label: 'Vehicle Arrived' },
      { key: 'Picked Up', label: 'Picked Up' },
      { key: 'Delivered', label: 'Delivered' },
      { key: 'POD Received', label: 'POD Received' },
      { key: 'Vessel Departed', label: 'Vessel Departed' },
      { key: 'Vessel Arrived', label: 'Vessel Arrived' },
      { key: 'Container Discharged', label: 'Container Discharged' },
      { key: 'Departed', label: 'Departed' },
      { key: 'Arrived', label: 'Arrived' },
    ].sort((a, b) => a.label.localeCompare(b.label))

    return {
      formValues: {
        eventStatus: null,
        eventTime: toLocalISOString(),
      },
      formErrors: {},
      fullObject: {
        status: {},
      },
      statusOptions,
    }
  },
  computed: {
    resourcefulQuery() {
      return {
        statusOption: (opts) => {
          let result = {}
          let statuses = this.statusOptions
          if (opts.search) {
            statuses = statuses.filter((item) =>
              item.label.toLowerCase().includes(opts.search.toLowerCase())
            )
          }
          result = {
            metadata: {
              total_page: 1,
              total_count: statuses.length,
              page: 1,
            },
            data: {
              paginated_result: statuses,
            },
          }

          return result
        },
      }
    },
  },
  methods: {
    onModalShow() {
      const toLocalISOString = (date = new Date()) => {
        const tzOffset = -date.getTimezoneOffset()
        const diff = tzOffset >= 0 ? '+' : '-'
        const pad = (n) => `${Math.floor(Math.abs(n))}`.padStart(2, '0')
        const hours = pad(tzOffset / 60)
        const minutes = pad(tzOffset % 60)
        return `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())}T${pad(
          date.getHours()
        )}:${pad(date.getMinutes())}:${pad(date.getSeconds())}.000${diff}${hours}:${minutes}`
      }

      this.formValues.eventTime = toLocalISOString()
      this.formValues.eventStatus = null
      this.fullObject.eventStatus = null
    },
    async handleConfirm() {
      if (this.$refs.formRef.hasErrors) {
        this.$refs.formRef.showErrors()
        return
      }

      const data = {
        event: this.formValues.eventStatus,
        event_time: this.formValues.eventTime,
      }

      const res = await DeliveryOrder.integrationShell(this.$route.params.id, data)
      if (res.errors) {
        this.$mcToast.error(`Gagal melakukan integrasi`)
        this.$bvModal.hide('modal-integration-shell')
        return
      }
      this.$mcToast.success(`Sukses melakukan integrasi`)
      this.$bvModal.hide('modal-integration-shell')
    },
  },
}
</script>
